<template>
  <div>
    <h2 class="ViewHeading">{{ this.FullName }}</h2>
    <h4>{{ this.Business }}</h4>
    <div>
      <b-row>
        <b-col>
          <div>
            <b-card class="text-center">
              <b-row>
                <b-col> <p class="boldheader">UserURN</p> </b-col>
                </b-row>
                <b-row>
                <b-col> <p class="value">{{ this.UserURN }}</p> </b-col>
              </b-row>
              <b-row>
                <b-col> <p class="boldheader">Default Location</p> </b-col>
                </b-row>
                <b-row>
                <b-col>
                  <p class="value"> {{ this.selectedlocation }}</p>
                </b-col>
              </b-row>
              <b-row><b-col><p class="boldheader">Other Locations</p></b-col></b-row>
              <b-row v-for="location in locations" :key="location.value">
                <b-col> <p class="value">{{ location.text }}</p> </b-col>
              </b-row>
              <b-row>
                <b-col> <p class="boldheader">Current IP</p> </b-col>
                </b-row>
                <b-row>
                <b-col><p class="value"> {{ this.IP }} </p> </b-col>
              </b-row>
              <b-row>
                <b-col> <p class="boldheader">Login Expires</p> </b-col>
                </b-row>
                <b-row>
                <b-col>
                  <p class="value"> {{ this.Login.substring(0, this.Login.length - 30) }} </p>
                </b-col>
              </b-row>
              <b-row>
                <b-col> <p class="boldheader">Access Groups</p> </b-col>
                </b-row>
                <b-row>
                <b-col>
                  <p class="value"> {{ this.CurrentAccessList }} </p>
                </b-col>
              </b-row>
              <b-card-text>
                <b-button
                  v-b-toggle="'editCollapse'"
                  size="sm"
                  variant="outline-info"
                  >User Edit</b-button
                >
                <b-collapse id="editCollapse">
                  <b-card>
                    <b-button
                      size="sm"
                      variant="outline-info"
                      @click="accessEdit()"
                      >Request Access Edit</b-button
                    >
                    <b-button
                      size="sm"
                      variant="outline-info"
                      @click="nameEdit()"
                      >Request Name Edit</b-button
                    >
                  </b-card>
                </b-collapse>
              </b-card-text>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-modal
      ref="EditUserAccess"
      id="EditUserAccess"
      title="Edit User Access Request"
      hide-footer
    >
      <p>Your current access group(s): {{ this.CurrentAccessList }}</p>
      <b-row>
        <b-col sm="6"> <p id="FormText">New Access Group</p> </b-col>
        <b-col sm="6" class="text-left">
          <b-form-group
            class="scrollList"
            label=""
            v-slot="{ ariaDescribedby }"
          >
            <b-form-checkbox-group
              v-model="NewAccessList"
              :options="AccessGroupArray"
              :aria-describedby="ariaDescribedby"
              name="SelectGroups"
              stacked
            ></b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-input
            v-model="NewAccessReason"
            placeholder="Reason for Request"
          ></b-form-input>
        </b-col>
      </b-row>
      <br />
      <b-button
        size="sm"
        variant="outline-info"
        @click="
          submitRequest(
            'EditUserAccess',
            CurrentAccessList,
            NewAccessList,
            NewAccessReason
          )
        "
        >Submit</b-button
      >
      <b-button
        size="sm"
        variant="outline-info"
        @click="Cancelrequest('EditUserAccess')"
        >Cancel</b-button
      >
    </b-modal>
    <b-modal
      ref="EditUserName"
      id="EditUserName"
      title="Edit User Name Request"
      hide-footer
    >
      <h2>{{ this.FullName }}</h2>
      <b-form-input
        v-model="NewName"
        placeholder="Enter New Name Request"
      ></b-form-input>
      <br />
      <b-form-input
        v-model="NewNameReason"
        placeholder="Reason for Request"
      ></b-form-input>
      <br />
      <b-button
        size="sm"
        variant="outline-info"
        @click="submitRequest('EditUserName', NewName, NewNameReason)"
        >Submit</b-button
      >
      <b-button
        size="sm"
        variant="outline-info"
        @click="Cancelrequest('EditUserName')"
        >Cancel</b-button
      >
    </b-modal>
  </div>
</template>
<script>
import axios from "axios";
export default {
  computed: {},
  components: {},
  data() {
    return {
      locAddress: "",
      locBuildingName: "",
      locTele: "",
      locEscEmail: "",
      locCountry: "",
      CountriesArray: [],
      RegionsArray: [],
      CountriesList: [],
      RegionsList: [],
      locRegion: [],
      UserURN: localStorage.getItem("UserURN"),
      selectedlocation: localStorage.getItem("CurrentLocation"),
      UserProfile: localStorage.getItem("profileportal"),
      FullName: localStorage.getItem("fullname"),
      Business: localStorage.getItem("Company"),
      IP: null,
      Login: localStorage.getItem("TokenExpiry"),
      NewName: "",
      NewNameReason: "",
      NewAccessReason: "",
      CurrentAccessList: localStorage.getItem("accessGroup"),
      NewAccessList: [],
      AccessGroupArray: [],
      locations: this.$locations,
    };
  },
  beforeMount() {},
  mounted() {
    axios.get("https://www.cloudflare.com/cdn-cgi/trace").then((response) => {
      this.IP = response.data.substring(
        response.data.search("ip=") + 3,
        response.data.search("ts=") - 1
      );
    });

    let LookUpUrlAccessGroup =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeadersAccessGroup = this.$apikeyPost;
    this.LookUpRequest3 = { RequestType: "AllAccessGroups" };
    axios
      .post(LookUpUrlAccessGroup, this.LookUpRequest3, LookUpHeadersAccessGroup)
      .then((response) => {
        let accessgrouplist = response.data.Values;
        for (let i = 0; i < accessgrouplist.length; i++) {
          this.AccessGroupArray.push({
            text: accessgrouplist[i][1],
            value: accessgrouplist[i][2],
          });
        }
      });
  },
  methods: {
    accessEdit() {
      this.$refs["EditUserAccess"].show();
    },
    nameEdit() {
      this.$refs["EditUserName"].show();
    },
    submitRequest(Type, var1, var2, var3) {
      this.$refs[Type].hide();
      if (Type == "EditUserName") {
        alert("Your name change request has been submitted");
        let NewNameSend = var1;
        let NameReasonSend = var2;
        this.EmailUserEdit = {
          ToEmail: "support@seraphprotect.online",
          EmailText:
            "Hello, \\n\\nThe following User has requested a name change. \\n\\nPlease follow up with the appropriate steps.\\nOriginal Name: " +
            this.FullName +
            "\\nNew Requested Name: " +
            NewNameSend +
            "\\nWith the following Reason: " +
            NameReasonSend +
            "\\n\\nSent from Seraph Protect",
          EmailSubject: "User Name Change Request",
        };
        this.HistoryNote = "Name Change Request";
        (this.NewName = ""), (this.NewNameReason = "");
      } else {
        alert("Your access change request has been submitted");
        let OriginalAccessListSend = var1;
        let NewAccessListSend = var2;
        let NewAccessReasonSend = var3;
        this.EmailUserEdit = {
          ToEmail: "support@seraphprotect.online",
          EmailText:
            "Hello, \\n\\nThe following User has requested an access change. \\n\\nPlease follow up with the appropriate steps.\\nOriginal Groups: " +
            OriginalAccessListSend +
            "\\nNew Requested Groups: " +
            NewAccessListSend +
            "\\nWith the following Reason: " +
            NewAccessReasonSend +
            "\\n\nUser is: "+
            this.FullName +
            "\\n\\nSent from Seraph Protect",
          EmailSubject: "User Access Change Request",
        };
        this.NewAccessList = [];
        this.NewAccessReason = "";
      }
      let EmailPosturl =
        "https://d9py0urct8.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/emailgateway";
      let EmailPostHeaders = this.$apikeyPost;
      axios
        .post(EmailPosturl, this.EmailUserEdit, EmailPostHeaders)
        .then((response) => {
          response;
          this.HistorySubmit();
        })
        .catch((err) => {
          "Error: ===", err;
        });
    },
    Cancelrequest(Type) {
      (this.NewName = ""), (this.NewNameReason = "");
      this.NewAccessReason = "";
      this.NewAccessList = [];
      this.$refs[Type].hide();
    },
    HistorySubmit() {
      let current = new Date();
      let HistoryDate =
        current.getFullYear() +
        "-" +
        (current.getMonth() + 1) +
        "-" +
        current.getDate();
      let HistoryTime =
        current.getHours() +
        ":" +
        current.getMinutes({ minimumIntegerDigits: 2 }) +
        ":" +
        current.getSeconds({ minimumIntegerDigits: 2, useGrouping: false });
      let LookUpURLHist =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/adminhistory";
      let LookUpHeadersHist = this.$apikeyPost;
      this.LookUpRequest = {
        UserURN: this.UserURN,
        HistoryDate: HistoryDate,
        HistoryTime: HistoryTime,
        HistoryNote: this.HistoryNote,
        ProfilePortal: this.UserProfile,
      };
      axios
        .post(LookUpURLHist, this.LookUpRequest, LookUpHeadersHist)
        .then((response) => {
          response;
        });
    },
  },
};
</script>
<style>
p.boldheader{
  font-weight: bold;
  margin-bottom: 2px;
}
p.value{
  font-size: medium;
  color: gray;
  margin-bottom: 8px;
}


</style>
